import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { gql } from 'apollo-boost';
import { Row, Col } from 'react-bootstrap';
import { Typography, Button } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton } from '@material-ui/core';
import { withRouter } from 'react-router';

import Logo from '../../../images/logo.png';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            showConfirmPassword: false,
            password: '',
            confirmPassword: '',
            errorMessage: '',
            email: this.props.location.state.email,
            code : this.props.location.state.code
        }
    }
    render() {
        const handleClickShowPassword = () => {
            this.setState({ ...this.state, showPassword: !this.state.showPassword });
        };
        const handleClickShowConfirmPassword = () => {
            this.setState({ ...this.state, showConfirmPassword: !this.state.showConfirmPassword });
        };
        const handleMouseDownPassword = event => {
            event.preventDefault();
        };
        const handleMouseDownConfirmPassword = event => {
            event.preventDefault();
        };
        const handleChange = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });
        };
        const CheckPassword = (inputtxt) => {
            var passw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
            if (inputtxt.match(passw)) {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
            else {
                this.setState({ ...this.state, errorMessage: 'The password must contains at least 8 characters that are uppercase and lowercase letters , special characters and numbers' });
                return false;
            }
        }
        return (
            <div className="container-custom pt-10">
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        if (CheckPassword(this.state.password) && CheckPassword(this.state.confirmPassword)) {
                            if (this.state.password === this.state.confirmPassword) {
                                this.props.mutate({
                                    variables: {
                                        email: this.state.email,
                                        password: this.state.password,
                                        pin_code : this.state.code
                                    }
                                }).then((res) => {
                                   if(res.data.passwordresets.Status.code === 200) {
                                        this.setState({ ...this.state, errorMessage: "Password Reset Successfully" })
                                        this.props.history.push({
                                            pathname: '/'
                                        });
                                    } else {
                                        this.setState({ ...this.state, errorMessage: "message error" })
                                    }
                                }).catch((err) => this.setState({ ...this.state, errorMessage: "Check your internet connection" }))
                            }
                            else {
                                this.setState({ ...this.state, errorMessage: "Password and confirmation password not match" })
                            }
                        }   
                    }}
                    className="container" autoComplete="off">
                    <div className="pt-1 pb-3">
                        <img src={Logo} alt="spreago logo" width="150px" />
                    </div>
                    <div className="pb-3">
                        <Typography variant="h4" color="primary" >Reset your password</Typography>
                    </div>
                    <div className="pt-1 pb-3">
                        <Typography variant="subtitle1" className="text-dark">Please enter your new password</Typography>
                    </div>
                    <FormControl required fullWidth className="mt-1" variant="outlined">
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <OutlinedInput
                            id="password"
                            type={this.state.showPassword ? 'text' : 'password'}
                            value={this.state.password}
                            onChange={handleChange('password')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={70}
                        />
                    </FormControl>
                    <FormControl required fullWidth className="mt-3" variant="outlined">
                        <InputLabel htmlFor="Confrm-Password">Confirm Password</InputLabel>
                        <OutlinedInput
                            id="Confrm-Password"
                            type={this.state.showConfirmPassword ? 'text' : 'Password'}
                            value={this.state.confirmPassword}
                            onChange={handleChange('confirmPassword')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowConfirmPassword}
                                        onMouseDown={handleMouseDownConfirmPassword}
                                        edge="end"
                                    >
                                        {this.state.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            labelWidth={125}
                        />
                    </FormControl>
                    <Row className="pt-3">
                        <Col xs={12}>
                            <div className="text-danger"><p>{this.state.errorMessage}</p></div>
                        </Col>
                        <Col xs={12} className="text-center">
                            <Button size="large" type="submit" variant="contained" color="primary" className="btn-orange-gradiant pr-5 pl-5">Continue</Button>
                        </Col>
                    </Row>

                </form>
            </div>
        );
    }
}

const RESET_PASSWORD = gql`
mutation( $password : Password !$email : Email ! $ pin_code : String !){
  passwordresets(data: {
    forgotPasswordInput:{
      password:$password
    }
  verifyPinCodeInput:{
    email:$email
    pin_code:$ pin_code
  }
  }){
    user{
      name
    }
    Status{
      message
      code
    }
  }
}
`;

export default graphql(RESET_PASSWORD)(withRouter(ResetPassword));